module.exports = __webpack_public_path__ + "media/images/nini_criancas-ba0253401f23e7c0bbc5c3f3e00869f7.png";